// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterProps.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import connect from 'share/enhancers/Izenda.Connect';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
import FilterPropsContainer from './Izenda.FilterPropsContainer';
import actions from './Izenda.FilterPropsActions';

@connect(actions)
export default class FilterProps extends PureComponent {
  static propTypes = {
    reportDesignerModel: PropTypes.object.isRequired,
    fieldStore: PropTypes.object.isRequired,
    localization: PropTypes.object
  };

  constructor(props) {
    super(props);

    props.cloneConfigField();
  }

  render() {
    const props = this.props;
    const { localization, reportDesignerModel, fieldStore } = props;

    return (
      <Popup visible onClosing={props.onClosing} type='none' autoClose={false} sizeClass='modal-md'>
        <Popup.Header title={localization.getText('COMMON_LABEL_FILTER_PROPERTIES')} />
        <Popup.Body className='izenda-FilterPropBodyContainer'>
          <div className='izenda-FilterPropBody'>
            <ScrollBox>
              <FilterPropsContainer isPopup reportDesignerModel={reportDesignerModel} fieldStore={fieldStore} />
            </ScrollBox>
          </div>
        </Popup.Body>
        <Popup.Footer>
          <Popup.ConfirmationButton key='accept' type='accept'>
            {localization.getText('COMMON_LABEL_OK')}
          </Popup.ConfirmationButton>
          <Popup.ConfirmationButton key='cancel' type='cancel'>
            {localization.getText('COMMON_LABEL_CANCEL')}
          </Popup.ConfirmationButton>
        </Popup.Footer>
      </Popup>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/Izenda.FilterProps.js